import { createContext, useContext, useMemo, useState } from 'react';
import { useSettings } from '@wu/widget-core';

export const LightboxContext = createContext({});
export const useLightbox = () => useContext(LightboxContext);

export const LightboxProvider = ({ children }) => {
  const [sources, setSources] = useState([]);
  const [sourceLink, setSourceLink] = useState('');
  const [showLightbox, toggleLightbox] = useState(false);

  const {
    imageCopyProtection,
    watermarkText,
    watermarkTextSize,
    watermarkPosition,
    watermarkType,
    watermarkLogo,
    watermarkLogoSize,
    widgetId
  } = useSettings();

  const lightboxContainerClass = 'lightbox-container-' + widgetId;

  const lightboxContextValue = useMemo(
    () => ({
      sources,
      setSources,
      sourceLink,
      setSourceLink,
      showLightbox,
      toggleLightbox,
      lightboxContainerClass,
      imageCopyProtection,
      watermarkText,
      watermarkTextSize,
      watermarkPosition,
      watermarkType,
      watermarkLogo,
      watermarkLogoSize
    }),
    [
      sources,
      setSources,
      sourceLink,
      setSourceLink,
      showLightbox,
      toggleLightbox,
      lightboxContainerClass,
      imageCopyProtection,
      watermarkText,
      watermarkTextSize,
      watermarkPosition,
      watermarkType,
      watermarkLogo,
      watermarkLogoSize
    ]
  );

  return (
    <LightboxContext.Provider value={lightboxContextValue}>
      {children}
    </LightboxContext.Provider>
  );
};
